import GiveLike from './GiveLike';

GiveLike.install = function(Vue) {
  Vue.component(GiveLike.name, GiveLike);
};

export default GiveLike;
